// extracted by mini-css-extract-plugin
export var editButton = "_mw-0";